export default "__VITE_ASSET__DTbiv7D$__"